module.exports = __webpack_public_path__ + "static/media/location1.0dbdb521.png";